






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListMediumHeavy } from '@/components/config'

// services
import { MediumHeavyService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { MediumHeavyForm, MediumHeavyModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditMediumHeavy from './modalCreateEdit.vue'

const newItem: MediumHeavyForm = {
  heavy: 0,
  piece: 0,
  rate: 0,
  is_active: true
}

@Component({
  name: 'MediumHeavyIndex',
  components: {
    PageHeader,
    TableListMediumHeavy,
    ModalCreateEditMediumHeavy
  }
})
export default class MediumHeavyIndex extends Vue {
  showModal = false
  heavy: MediumHeavyForm = newItem
  title = 'Configuración de Pesadas'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Pesadas',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.heavy = newItem
    this.showModal = true
  }

  editItem (item: MediumHeavyModel) {
    this.heavy = {
      heavy: item.heavy,
      piece: item.piece,
      rate: item.rate,
      is_active: item.is_active
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: MediumHeavyModel) {
    const msg = 'Seguro que desea eliminar Pesada seleccionada'
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await MediumHeavyService.delete(item.id)
      alerts.success()
      this.tableList.getheavyWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await MediumHeavyService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getheavyWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getheavyWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getheavyWithPagination: () => void }
  }

  get itemInit (): MediumHeavyForm {
      return newItem
  }
}
